(() => {
  if (typeof document !== 'undefined' && !document.querySelector('link[data-froala-css]')) {
    const base = (document.querySelector('base') as HTMLBaseElement)?.href || '/';
    ['froala-editor.css', 'froala-style.css'].forEach(file => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = base + file;
      link.setAttribute('data-froala-css', '');
      document.head.appendChild(link);
    });
  }
})();

import 'froala-editor/js/plugins/font_family.min.js';
import 'froala-editor/js/plugins/font_size.min.js';
import 'froala-editor/js/plugins/colors.min.js';
import 'froala-editor/js/plugins/link.min.js';
import 'froala-editor/js/plugins/paragraph_format.min.js';
import 'froala-editor/js/plugins/paragraph_style.min.js';
import 'froala-editor/js/plugins/lists.min.js';
import 'froala-editor/js/plugins/align.min.js';
import 'froala-editor/js/plugins/line_breaker.min.js';